import script from "./dayOverviewSimple.vue?vue&type=script&setup=true&lang=js"
export * from "./dayOverviewSimple.vue?vue&type=script&setup=true&lang=js"

import "./dayOverviewSimple.vue?vue&type=style&index=0&id=b7757fe4&scoped=true&lang=scss"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7757fe4"]])

export default __exports__